import { useNavigate } from 'react-router';
import { EmptyState } from './components/empty-state';
import { ListPlans } from './components/list-plans';
import { AiChip } from '@/components/shared/ai-chip';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { PageSkeleton } from '@/components/shared/page-skeleton';
import { usePlans } from '@/data/idp/plans';
import { useSetTitle } from '@/hooks/use-set-title';

export const Idp = () => {
  useSetTitle('Plano personalizado');
  const navigate = useNavigate();
  const { plans, plansCount, isLoading } = usePlans();

  const handleNewPlan = () => {
    navigate('/pdi/planos/novo');
  };

  if (isLoading) return <PageSkeleton />;

  return (
    <PageContainer>
      <PageHeader
        title="Plano Personalizado"
        buttonText="Novo plano"
        buttonOnClick={handleNewPlan}
        tag={<AiChip />}
      />
      {plansCount ? <ListPlans plans={plans} /> : <EmptyState />}
    </PageContainer>
  );
};
